import { StyleSheet, TouchableOpacity, View } from "react-native";
import React from "react";
import CallCircleBlue from "@assets/svg/CallCircleBlue";
import RightArrow from "@assets/svg/RightArrow";
import ActiveCashBack from "@assets/svg/ActiveCashBack";
import DisableCashBack from "@assets/svg/DisableCashBack";
import GreenTick from "@assets/svg/GreenTick";
import ToBeCompleteStepIndicator from "@assets/svg/ToBeCompleteStepIndicator";
import UnTickStepIndicator from "@assets/svg/UnTickStepIndicator";
// import CancelledStepIndicator from "@assets/svg/CancelledStepIndicator";
import LockCashBack from "@assets/svg/LockCashBack";
import t from "@constants/localization";
import Text from "@components/CustomText";
import colors from "@constants/color";

const PATH = "screens/ReferEarn";

const ReferralStatusCard = ({
  name,
  phoneNumber,
  amount,
  remember,
  steps,
  referralCommissionProcessed,
}) => {
  return (
    <View style={styles.container}>
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <View style={{ justifyContent: "space-between" }}>
          <View style={{ flexDirection: "row" }}>
            <View style={styles.circle}>
              <Text style={styles.avatarText}>{name.charAt(0)}</Text>
            </View>
            <View>
              <Text variant="caption_1" style={styles.customerText}>
                {name}
              </Text>
              <Text variant="caption_2" style={styles.customerPhoneText}>
                +91 {phoneNumber}
              </Text>
            </View>
          </View>
          <TouchableOpacity
            style={styles.callContainer}
            disabled={referralCommissionProcessed}
            onPress={() => remember(phoneNumber)}
          >
            <CallCircleBlue
              color={referralCommissionProcessed ? "rgba(0, 0, 0, 0.1)" : ""}
            />
            <Text
              variant="caption_1"
              style={
                referralCommissionProcessed
                  ? [styles.callTitleText, styles.disableCallTitleText]
                  : styles.callTitleText
              }
            >
              {t(`${PATH}/remindThem`)}{" "}
            </Text>
            <RightArrow
              stroke={
                referralCommissionProcessed ? "rgba(0, 0, 0, 0.1)" : "#000"
              }
              fill={referralCommissionProcessed ? "rgba(0, 0, 0, 0.1)" : "#000"}
            />
          </TouchableOpacity>
        </View>
        <View>
          <View style={styles.referralAmountContainer}>
            <Text
              variant="caption_1"
              style={
                referralCommissionProcessed
                  ? styles.referralAmountText
                  : styles.referralDisabledAmountText
              }
            >
              ₹{amount}
            </Text>
          </View>
          {!referralCommissionProcessed && (
            <View style={styles.referralAmountContainer}>
              <LockCashBack />
            </View>
          )}
          {referralCommissionProcessed && <ActiveCashBack />}
          {!referralCommissionProcessed && <DisableCashBack />}
        </View>
      </View>
      <View style={styles.stepContainer}>
        {steps.map((step) => (
          <View key={step.id} style={styles.tickContainer}>
            {step.toBeCompletedIndicator && <ToBeCompleteStepIndicator />}
            {step.unTickStep && <UnTickStepIndicator />}
            {step.stepConfirmed && <GreenTick />}
            <Text variant="caption_2" style={styles.tickText}>
              {step.name.replace("$", `₹ ${amount}`)}
            </Text>
            {step.lineConfirmed && <View style={styles.tickLine} />}
            {step.dashedLine && (
              <View
                style={[
                  styles.tickLine,
                  { borderStyle: "dashed", borderColor: "rgba(0, 0, 0, 0.1)" },
                ]}
              />
            )}
          </View>
        ))}
      </View>
    </View>
  );
};

export default ReferralStatusCard;

const styles = StyleSheet.create({
  container: {
    padding: 15,
    backgroundColor: "#fff",
    marginTop: 10,
  },
  circle: {
    height: 40,
    width: 40,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.primary,
    borderRadius: 40,
    marginRight: 10,
  },
  avatarText: {
    fontSize: 16,
    color: "#fff",
  },
  customerText: {
    color: "rgba(0, 0, 0, 0.86)",
    fontSize: 14,
    fontWeight: "700",
  },
  customerPhoneText: {
    color: "rgba(0, 0, 0, 0.56)",
    fontSize: 12,
    fontWeight: "400",
  },
  callContainer: {
    borderColor: "rgba(0, 0, 0, 0.2)",
    borderWidth: 1,
    borderRadius: 6,
    paddingVertical: 6,
    paddingHorizontal: 20,
    flexDirection: "row",
    alignItems: "center",
  },
  callTitleText: {
    color: "rgba(0, 0, 0, 0.86)",
    fontSize: 16,
    fontWeight: "700",
    marginHorizontal: 5,
  },
  disableCallTitleText: {
    color: "rgba(0, 0, 0, 0.1)",
  },
  stepContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
  },
  tickContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 10,
    width: "18%",
  },
  tickText: {
    color: "rgba(0, 0, 0, 0.86)",
    fontSize: 11,
    marginTop: 8,
    width: 100,
    minHeight: 30,
    maxHeight: 40,
    textAlign: "center",
    bottom: 0,
  },
  tickLine: {
    height: 0,
    borderWidth: 1,
    width: "210%",
    borderColor: "rgba(0, 171, 89, 1)",
    left: 34,
    top: 20,
    position: "absolute",
    zIndex: -1,
  },
  referralAmountContainer: {
    position: "absolute",
    zIndex: 1,
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  referralAmountText: {
    fontSize: 20,
    color: "rgba(65, 65, 65, 1)",
    fontWeight: "700",
  },
  referralDisabledAmountText: {
    fontSize: 20,
    color: "rgba(65, 65, 65, 0.2)",
    fontWeight: "700",
  },
});
